let timer;

export default {
    async auth(context,payload){
        const mode = payload.mode
        let link = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCRZdBSdwqRLrUvDgfkrAwvx_rAnId6q08'
        if(mode === 'signup'){
            link = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyCRZdBSdwqRLrUvDgfkrAwvx_rAnId6q08'
        }
        const response = await fetch(link,
        {
            method:'POST',
            body:JSON.stringify({
                email: payload.email,
                password: payload.password,
                returnSecureToken: true
            })
        })
        const responseData = await response.json();
        if(!response.ok){
            const error = new Error(responseData.error.message || `Failed to ${mode}!! `)
            throw error
        }
      
        const expiresIn = responseData.expiresIn *1000;
        const expirationTime = new Date().getTime() + expiresIn;
         timer = setTimeout(()=>{
            context.dispatch('logout')
          
        },expiresIn)
        let userData = {
            userId: responseData.localId,
            token: responseData.idToken,
        }
        localStorage.setItem('token',responseData.idToken)
        localStorage.setItem('userId',responseData.localId)
        localStorage.setItem('expirationTime',expirationTime)   
        context.commit('setUser',userData)
    },
    tryLogin(context){
        const userId = localStorage.getItem('userId')
        const token = localStorage.getItem('token')
        const expirationTime = localStorage.getItem('expirationTime')
        const remainingTime =  expirationTime - new Date().getTime() ;
        if(remainingTime < 0){
         
            context.dispatch('autoLogout')
            return;
        }
        timer = setTimeout(()=>{
            context.dispatch('autoLogout');
        },remainingTime)
        if(userId && token){
            context.commit('setUser',{
                userId,token
            })
        }
    },
    async login(context,payload){
       return context.dispatch('auth',{
        ...payload,
        mode: 'login',
       })
    },
    async signup(context,payload){
       return context.dispatch('auth',{
        ...payload,
        mode:'signup'
       })
    },
    logout(context){
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        localStorage.removeItem('expirationTime')
        clearTimeout(timer)
        context.commit('setUser',{})
    },
    autoLogout(context){
        context.dispatch('logout')
        context.commit('setAutoLogout')

    }
}

